import qs from 'qs';
import { useEffect, useState } from 'react';
import InfiniteScroll from "react-infinite-scroll-component";
import { useHistory, useParams } from 'react-router-dom';
import { get2ndCategories, getSubCategories } from '../apis/category';
import { getCategorySizes, getProductDetail, getProductList } from '../apis/products';
import { FilterBar } from '../components/FilterBar';
import { HorizontalScrollView } from '../components/HorizontalScrollView';
import { Icon } from '../components/Icon';
import { ProductCard } from '../components/ProductCard';
import { Section } from '../components/Section';
import {ProductQuery, ProductSizeCode, TargetType, TSubCategory, ScoreType} from '../types/types';
// @ts-ignore
//import injectSizesIntoProductList from '../utils/injectSizesIntoProductList';
import { AIRBRIDGE_EVENT } from '../constants/airbridge';
import { BRAZE_EVENT } from '../constants/braze';
import { useUserDispatch, useUserState } from "../context/UserContext";
import { Bridge } from '../plugins/bridge';
import injectSizesIntoProductList from "../utils/injectSizesIntoProductList";

async function onClickProduct(product: ProductQuery) {
    var detailData = await getProductDetail(product?.productId).then((value) => {
        // console.log(value.data.payload)
        return value.data.payload;
    });
    const itemEventProperties = {
        item_id: [String(product?.productId)],
        item_name: [String(product?.productName)],
        item_category: [String(detailData.categoryCode)],
        item_color: [String(product.color)],
        item_gender: [String(detailData.genderCode)],
        item_price: [Number(product?.initialPrice)],
        item_discount_rate: [Number(product?.discountedRate)],
        item_discount_price: [Number(product?.currentPrice)]
    };
    console.log(itemEventProperties);
    Bridge.sendAmplitude('item_clicked', itemEventProperties);
}

export type TSortType =
    | 'currentPriceDesc'
    | 'currentPriceAsc'
    | 'seasonCodeDesc'
    | 'popularity'
    ;

export const ProductListPage = () => {
    const { push, location } = useHistory();
    const { products, lastQuery, setSale, setMidSale } = useUserState();
    const query = qs.parse(location.search, { ignoreQueryPrefix: true });
    const se = query.se;
    const productSize = query.size as string;
    const sortType = query.sort as TSortType ?? "";
    const sale = query.sale as string || setSale;
    const midSale = query.midSale as string || setMidSale;
    const page = query.page as string;
    const params = useParams<{
        categoryName?: string;
        categoryIdString?: string;
        subCategoryIdString?: string;
    }>();
    const { categoryName, categoryIdString, subCategoryIdString } = params;
    const name = categoryName;
    const main = !!categoryIdString ? Number(categoryIdString) : undefined;
    const sub = !!subCategoryIdString ? Number(subCategoryIdString) : undefined;
    const [subCategory, setSubCategory] = useState<TSubCategory>();
    const [secondCategory, setSecondCategory] = useState<TSubCategory[]>([]);
    const [finalPage, setFinalPage] = useState<number>(0);
    const [sizeFilters, setSizeFilters] = useState<ProductSizeCode[]>([]);

    const dispatch = useUserDispatch();
    const [isScroll, setIsScroll] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [isFirst, setIsFirst] = useState<boolean>(true);


    useEffect(() => {
        setSizeFilters([]);
    }, [main, sub]);

    useEffect(() => {
        setIsLoading(true);
        main && getSubCategories(main).then(r => {
            const data = r.data.payload;
            const index = data.findIndex(
                item => item.subcategoryId === sub,
            );
            const secTab = secondCategory && se ? secondCategory.find(it => it.subcategoryId === +(se || 0))?.name : '전체';
            const product_size = productSize == undefined ? 'All' : productSize;
            const sale_filter = sale == 'true' ? 'On' : 'Off';
            const productListID = sub ? sub : main;

            if (categoryName != undefined) {
                if (isFirst) {
                    Bridge.sendAmplitude('product_menu_clicked', {
                        main_tab: String(categoryName),
                        sub_tab: (sub == undefined) && (index == -1) ? '전체' : data[index].name
                    });
                    Bridge.sendBraze(BRAZE_EVENT.PRODUCT_MENU_CLICKED, {
                        main_tab: String(categoryName),
                        sub_tab: (sub == undefined) && (index == -1) ? '전체' : data[index].name
                    });
                    setIsFirst(false);
                }

                Bridge.sendAmplitude('item_total_page_viewed',
                    {
                        main_tab: String(categoryName),
                        sub_tab: (sub == undefined) && (index == -1) ? '전체' : data[index].name,
                        sec_tab: secTab,
                        category_filter: sub === undefined ? '전체' : data[index].name,
                        size_filter: product_size,
                        sale_filter: sale_filter
                    }
                );

                Bridge.sendBraze(BRAZE_EVENT.ITEM_TOTAL_PAGE_VIEWED, {
                    main_tab: String(categoryName),
                    sub_tab: (sub == undefined) && (index == -1) ? '전체' : data[index].name,
                    sec_tab: secTab,
                    category_filter: (sub == undefined) && (index == -1) ? '전체' : data[index].name,
                    size_filter: product_size,
                    sale_filter: sale_filter
                });

                Bridge.sendAirbridge(AIRBRIDGE_EVENT.productCatalog, {
                    action: String(categoryName),
                    label: (sub == undefined) && (index == -1) ? '전체' : data[index].name,
                    semanticAttributes: {
                        productListID: productListID
                    }
                });
            }
            setSubCategory(data[index]);
            if (!sub) {
                setSecondCategory(r.data.payload);
            }
        }).catch(e => console.log(e));
        main && getCategorySizes(main, secondCategory.find(item => item.name === se)?.subcategoryId || sub).then(
            r => {
                if (!!sub) {
                    setSizeFilters(r.data.payload[0].sizes);
                } else {
                    let list: ProductSizeCode[] = [];
                    r.data.payload.forEach(item => {
                        list.push(...item.sizes);
                    });
                    setSizeFilters(list);
                }
            },
        ).catch(e => console.log(e));
    }, [main, sub, sortType, productSize, sale, se]);


    useEffect(() => {
        (subCategory && sub) &&
            get2ndCategories(sub, subCategory.categoryCodes).then(r => {
                setSecondCategory(r.data.payload);
            }).catch(e => console.log(e));
    }, [subCategory, sub]);

    useEffect(() => {
        setIsScroll(false);
        if (location.pathname + location.search !== lastQuery) {
            window.scrollTo(0, 0);
            dispatch({ type: 'RESET_PRODUCTS' });
            dispatch({ type: 'SET_LAST_QUERY', payload: location.pathname + location.search });
            dispatch({ type: 'SET_MID_SALE', payload: location.pathname.includes('미드세일') ? 'true' : 'false' });
            if (sale) dispatch({ type: 'SET_SALE', payload: sale });
            getList().then(r => {
                setFinalPage(r.data.payload.totalPages);
                injectSizesIntoProductList(r.data.payload.content).then((productList: ProductQuery[]) => {
                    dispatch({
                        type: 'SET_PRODUCTS',
                        payload: productList,
                    });
                    setIsLoading(false)
                })
            }).catch(e => console.log(e));
        }

    }, [main, sub, secondCategory, productSize, sale, midSale, se, sortType]);

    useEffect(() => {
        if (finalPage !== 0 && parseInt(page) > finalPage) {
            return;
        } else if (location.pathname + location.search !== lastQuery && parseInt(page) > 0) {
            dispatch({ type: 'SET_LAST_QUERY', payload: location.pathname + location.search });
            getList().then(r => {
                setFinalPage(r.data.payload.totalPages);
                injectSizesIntoProductList(r.data.payload.content).then((productList: ProductQuery[]) => {
                    if (productList.length == 0 && parseInt(page) == finalPage) {
                        setIsScroll(false)
                        //push(location.pathname)
                    }
                    dispatch({type: 'SET_PRODUCTS', payload: [...products, ...productList]});
                    setIsLoading(false)
                }).catch(e => console.log(e));
            }).catch(e => console.log(e));
        }
    }, [page]);

    const getList = () => getProductList({
        mainCategoryId: main,
        subcategoryId: sub || undefined,
        secondCategoryId: se && Number(se) || undefined,
        sale: sale === 'true' ? true : undefined,
        midSale: midSale === 'true' ? true : undefined,
        productSize: productSize,
        sort: sortType,
        page: parseInt(page) || 0,
        size: 12,
    });

    if (!main) return null;
    return (
        <>
            {/* Desktop CategoryBar */}
            <Section className="hidden p-3 md:flex items-center">
                <div className="w-1/6">{`${name}, ${!!subCategory ? subCategory.name : '전체'}`}</div>

                <div
                    className="flex max-w-screen-xl space-x-3 items-center overflow-x-auto whitespace-nowrap no-scrollbar">
                    <button
                        className={`${se === undefined ? 'bg-brand-1 text-white' : 'bg-brand-2'
                            }  px-3 py-2 rounded-md text-13`}
                        onClick={() => push(`${setMidSale === 'true' ? '?midSale=true&sort=popularity&page=0' : (setSale === 'true' ? '?sale=true' : '?')}`)}>
                        전체
                    </button>
                    {secondCategory.sort((a, b) => b.sort - a.sort).map((item, index) => (
                        <button
                            key={index}
                            className={`${se === item.subcategoryId.toString()
                                ? 'bg-brand-1 text-white'
                                : 'bg-brand-2'
                            }  px-3 py-2 rounded-md w-max text-13`}
                            onClick={() => !!subCategoryIdString ?
                                push(`?se=${item.subcategoryId}${setMidSale === 'true' ? '&midSale=true&sort=popularity&page=0' : (setSale === 'true' ? '&sale=true' : '')}`)
                                :
                                push(`/p/${name}/${categoryIdString}/${item.subcategoryId}${setMidSale === 'true' ? '?midSale=true&sort=popularity&page=0' : (setSale === 'true' ? '?sale=true' : '')}`)}
                        >
                            {item.name}
                        </button>
                    ))}
                    {secondCategory.length > 0 && (
                        <button className="wh-6 rounded-full bg-brand-2 grid place-items-center">
                            <Icon.ArrowRight className="wh-4" />
                        </button>
                    )}
                </div>
            </Section>

            {/* Mobile CategoryBar */}
            <Section className="md:hidden pt-2">
                <div className="grid place-items-center ">
                    {`${name}, ${!!subCategory ? subCategory.name : '전체'}`}
                </div>
                {secondCategory.length > 0 && (
                    <HorizontalScrollView className="border-b border-t py-2 mt-2 no-scrollbar">
                        <button
                            className={`${se === undefined
                                ? 'bg-brand-1 text-white'
                                : 'bg-brand-2'
                                }  px-3 py-2 rounded-md w-max text-14`}
                            onClick={() => push(`${setMidSale === 'true' ? '?midSale=true&sort=popularity&page=0' : (setSale === 'true' ? '?sale=true' : '?')}`)}>
                            전체
                        </button>
                        {secondCategory.sort((a, b) => b.sort - a.sort).map((item, index) => (
                            <button
                                key={index}
                                className={`${se === item.subcategoryId.toString()
                                    ? 'bg-brand-1 text-white'
                                    : 'bg-brand-2'
                                }  px-3 py-2 rounded-md w-max text-14`}
                                onClick={() => !!subCategoryIdString ?
                                    push(`?se=${item.subcategoryId}${setMidSale === 'true' ? '&midSale=true&sort=popularity&page=0' : (setSale === 'true' ? '&sale=true' : '')}`)
                                    :
                                    push(`/p/${name}/${categoryIdString}/${item.subcategoryId}${setMidSale === 'true' ? '?midSale=true&sort=popularity&page=0' : (setSale === 'true' ? '?sale=true' : '')}`)}>
                                {item.name}
                            </button>
                        ))}
                        <div className='py-2'>
                            <button className="wh-6 rounded-full bg-brand-2 grid place-items-center">
                                <Icon.ArrowRight className="wh-4" />
                            </button>
                        </div>
                    </HorizontalScrollView>
                )}
            </Section>

            <div className="max-w-screen-2xl mx-auto">
                <FilterBar
                    sizeFilters={sizeFilters}
                    sizeValue={productSize}
                    onSelectSize={sizeName => push(`?${qs.stringify({ ...query, size: sizeName, page: 0 })}`)}
                    sortValue={sortType}
                    onSort={sortType => push(`?${qs.stringify({ ...query, sort: sortType || undefined, page: 0 })}`)}
                    checked={sale === 'true'}
                    onChecked={() => {
                        sale === 'true' ? dispatch({ type: 'SET_SALE', payload: 'false' }) : dispatch({ type: 'SET_SALE', payload: 'true' });
                        push(`?${qs.stringify({
                            ...query,
                            sale: sale === 'true' ? undefined : 'true',
                            page: 0
                        })}`);
                    }
                    }
                />
            </div>
            <InfiniteScroll
                next={() => push(`?${qs.stringify({ ...query, page: (parseInt(page) || 0) + 1 })}`)}
                dataLength={products.length}
                hasMore={isScroll}
                loader={<></>}
                onScroll={() => setIsScroll(true)}
            >
                <div
                    className="grid lg:grid-cols-4 md:grid-cols-3 grid-cols-2 gap-x-2 gap-y-8 max-w-screen-2xl md:mx-auto md:px-0 overflow-hidden">
                    {products.map((product, index) => (
                        <ProductCard
                            key={index}
                            product={product}
                            onClick={() => {
                                push(`/product/${product.productId}`);
                                onClickProduct(product);
                            }}
                        />
                    ))}
                </div>
            </InfiniteScroll>
            <div className="flex justify-center mt-10 pb-20 top_banner_b">
                {isLoading && (
                    <div className="lds-ring">
                        <div>
                            <svg width="30" height="27" viewBox="0 0 36 40" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_603_6335)">
                                    <path
                                        d="M29.0892 18.6716C23.2227 18.6716 21.3293 14.4378 21.3293 11.5445C21.3293 6.36019 25.3706 3.90462 28.2998 3.90462C31.229 3.90462 32.2973 5.2051 32.2973 5.2051C31.9487 5.08792 31.5826 5.02959 31.2144 5.03255C27.6887 5.03255 26.7906 7.9738 26.7906 9.44203C26.7906 11.3592 28.2009 13.647 31.2144 13.647C34.7612 13.647 35.5912 10.653 35.5912 9.23593C35.5912 5.08208 31.3457 0 20.809 0C9.75511 0 0.00781636 9.50913 0.00781636 20.0551C-0.000288831 35.4164 12.767 39.9984 20.2076 39.9984H35.9997V13.9569C34.9104 16.772 32.4448 18.6716 29.0892 18.6716Z"
                                        fill="#2F2F2F" />
                                </g>
                                <defs>
                                    <clipPath id="clip0_603_6335">
                                        <rect width="36" height="40" fill="white" />
                                    </clipPath>
                                </defs>
                            </svg>
                        </div>
                    </div>
                )}
                {(!isLoading && products.length == 0) && (
                    <div className="text-14">
                        <p>판매중인 상품이 없습니다.</p>
                    </div>
                )}
            </div>
        </>
    );
}

